import { render, staticRenderFns } from "./RmcConfTile.vue?vue&type=template&id=4e967bf0&scoped=true&"
import script from "./RmcConfTile.vue?vue&type=script&lang=js&"
export * from "./RmcConfTile.vue?vue&type=script&lang=js&"
import style0 from "./RmcConfTile.vue?vue&type=style&index=0&id=4e967bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e967bf0",
  null
  
)

export default component.exports